module.exports = __webpack_public_path__ + "static/media/ma.0150c739.svg";